import { lazy, Suspense } from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import { Layout } from './layouts/Layout';
import { TurneroProvider } from './context/TurneroContext';
import { AnalyticsRoot } from './features/turnero/components/AnalyticsRoot';
import { TagManagerRoot } from './features/turnero/components/TagManagerRoot';

const SolicitarPage = lazy(() =>
  import('./features/turnero/components/SolicitarWizard').then((m) => ({ default: m.SolicitarWizard }))
);
const DescargarPage = lazy(() =>
  import('./features/turnero/components/flows/DescargarTurnoFlow').then((m) => ({ default: m.DescargarTurnoFlow }))
);
const ReprogramarPage = lazy(() =>
  import('./features/turnero/components/flows/ReprogramarTurnoFlow').then((m) => ({ default: m.ReprogramarTurnoFlow }))
);
const CancelarPage = lazy(() =>
  import('./features/turnero/components/flows/CancelarTurnoFlow').then((m) => ({ default: m.CancelarTurnoFlow }))
);

const App = () => (
  <BrowserRouter
      basename={process.env.PUBLIC_URL}
      future={{ v7_startTransition: true, v7_relativeSplatPath: true }}
    >
      <TurneroProvider>
        <AnalyticsRoot />
        <TagManagerRoot />
        <Suspense fallback={null}>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<SolicitarPage />} />
              <Route path="/solicitar" element={<Navigate to="/" replace />} />
              <Route path="/turno" element={<Navigate to="/descargar" replace />} />
              <Route path="/descargar" element={<DescargarPage />} />
              <Route path="/reprogramar" element={<ReprogramarPage />} />
              <Route path="/cancelar" element={<CancelarPage />} />
              <Route path="*" element={<Navigate to="/" replace />} />
            </Route>
          </Routes>
        </Suspense>
      </TurneroProvider>
  </BrowserRouter>
);

export default App;
